import React, { Component, PropTypes } from 'react'
import { browserHistory } from 'react-router'

import { detectAndShowErrors, getProperty } from './utils'

import { formHandler, Button } from './ui'

import Header from './header'
import Progress from '../containers/progress'
import { Loading } from './misc'

import * as GearComponents from './gear/index'

class Gear extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.shape({
                crew: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
        appState: PropTypes.object,
        gear: PropTypes.shape({
            data: PropTypes.object,
        }).isRequired,
        gearActions: PropTypes.shape({
            commitGearData: PropTypes.func.isRequired,
            loadGear: PropTypes.func.isRequired,
        }).isRequired,
        modalActions: PropTypes.object,
        personal: PropTypes.shape({
            data: PropTypes.object,
        }).isRequired,
        personalActions: PropTypes.shape({
            loadPersonal: PropTypes.func.isRequired,
        }).isRequired,
        routeParams: PropTypes.shape({
            type: PropTypes.string.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: this.props.gear.data,
        }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        this._resolveCrewType(this.props)

        if (! this.props.personal.data) {
            this.props.personalActions.loadPersonal(this.props.account.user.crew.uuid)
        }
        if (! this.props.gear.data) {
            this.props.gearActions.loadGear(this.props.account.user.crew.uuid)
        }
    }

    componentWillReceiveProps(nextProps) {
        this._resolveCrewType(nextProps)

        // update the state data when we receive new gear data props
        if (nextProps.gear && ! (
            this.props.gear &&
            nextProps.gear.data === this.props.gear.data
        )) {
            this.setState({
                data: nextProps.gear.data,
            })
        }

        detectAndShowErrors(this.props, nextProps, 'gear.errors')
    }

    _commitGear = (e) => {
        if (e.button === 0) {
            e.preventDefault()

            this.props.gearActions.commitGearData(
                this.props.routeParams.type,
                this.props.account.user.crew.uuid,
                this.state.data,
                this.props.personal.data,
            )
        }
    }

    _resolveCrewType(props) {
        this.crewType = null

        const personalData = getProperty(props, 'personal.data')
        const routeParams = getProperty(props, 'routeParams')

        if (personalData) {
            if (routeParams.type === 'primary' && personalData.type) {
                this.setState({ crewType: personalData.type_obj })
            } else if (routeParams.type === 'secondary' && personalData.crew_secondary_type) {
                this.setState({ crewType: personalData.crew_secondary_type_obj })
            } else if (routeParams.type === 'tertiary' && personalData.crew_tertiary_type) {
                this.setState({ crewType: personalData.crew_tertiary_type_obj })
            } else {
                // if we got here, either the user has typed the URL incorrectly, or they don't
                // actually have the crew position set up (e.g going to `/gear/tertiary` when they
                // say there's no tertiary position applicable to them), so just redirect to the
                // crew positions page
                browserHistory.replace('/crew-positions')
            }
        }
    }

    _getComponentsForCrewType(crewType) {
        const components = []

        const defaultProps = {
            appState: this.props.appState,
            crew_uuid: this.props.account.user.crew.uuid,
            crewType: crewType.value,
            data: this.state.data,
            gear: this.props.gear,
            gearActions: this.props.gearActions,
            modalActions: this.props.modalActions,
            personal: this.props.personal,
            personalActions: this.props.personalActions,
            updateValue: this._updateValue,
        }

        // see https://gitlab.com/mwac/mwac-web-app/issues/23
        switch (crewType.identifier) {
            case 'ANIMATOR':
            case 'COLORIST':
                components.push(
                    <GearComponents.Computers { ...defaultProps } key="component-1" />,
                    <GearComponents.Software { ...defaultProps } key="component-2" type="color" />,
                    <GearComponents.AdditionalSoftware { ...defaultProps } key="component-3" />,
                    <GearComponents.AdditionalHardware { ...defaultProps } key="component-4" />,
                    <GearComponents.ColouristAnimatorPostSkills { ...defaultProps } key="component-5" />,
                    <GearComponents.Monitors { ...defaultProps } key="component-6" />,
                )
                break
            case 'CAMERA-ASSISTANT':
                components.push(
                    <GearComponents.CameraAssistant { ...defaultProps } key="component-1" />,
                    <GearComponents.AdditionalGear
                        { ...defaultProps }
                        addLabel="Add kit details"
                        key="component-2"
                        title="First AC / Camera Assistant Kit & Gear"
                    />,
                )
                break
            case 'DIT':
                components.push(
                    <GearComponents.ComputersSimple { ...defaultProps } key="component-1" />,
                    <GearComponents.AdditionalGear
                        { ...defaultProps }
                        addLabel="Add kit details"
                        key="component-2"
                        title="Additional DIT Gear"
                    />,
                    <GearComponents.DITSoftware { ...defaultProps } key="component-3" />,
                    <GearComponents.Monitors { ...defaultProps } key="component-4" />,
                )
                break
            case 'DRONE-AERIAL-CAM':
                components.push(
                    <GearComponents.Drones { ...defaultProps } key="component-1" />,
                    <GearComponents.AdditionalGear
                        { ...defaultProps }
                        addLabel="Add item"
                        key="component-2"
                        title="Additional Drone Kit Gear"
                    />,
                    <GearComponents.DroneQuestions { ...defaultProps } key="component-3" />,
                    <GearComponents.ComputersSimple { ...defaultProps } key="component-4" />,
                )
                break
            case 'EDITOR':
                components.push(
                    <GearComponents.Computers { ...defaultProps } key="component-1" />,
                    <GearComponents.Software { ...defaultProps } key="component-2" type="editing" />,
                    <GearComponents.AdditionalSoftware { ...defaultProps } key="component-3" />,
                    <GearComponents.Monitors { ...defaultProps } key="component-4" />,
                    <GearComponents.EditorPostSkills { ...defaultProps } key="component-5" />,
                )
                break
            case 'FIELD-PRODUCER':
                components.push(
                    <GearComponents.ComputersSimple { ...defaultProps } key="component-1" />,
                    <GearComponents.AdditionalGear
                        { ...defaultProps }
                        key="component-2"
                        title="Other Production Equipment"
                    />,
                    <GearComponents.Transportation { ...defaultProps } key="component-3" />,
                )
                break
            case 'GAFFER':
            case 'KEY-GRIP':
                components.push(
                    <GearComponents.OwnLighting { ...defaultProps } key="component-1" />,
                )

                // add the video lighting kits section if the gaffer says they have lighting/grip
                // equipment
                if (getProperty(this.state.data, 'gaffer_own_lighting', false) === true) {
                    components.push(
                        <GearComponents.LightingKits { ...defaultProps } key="component-2" type="video" />,
                    )
                }

                components.push(
                    <GearComponents.AdditionalGear
                        { ...defaultProps }
                        addLabel="Add item"
                        help="Please list additional equipment and accessories you own and want us to know about."
                        key="component-3"
                        title={ `${ crewType.label } Kit & Gear` }
                    />,
                )
                break
            case 'HAIR-STYLIST':
            case 'MAKE-UP-ARTIST':
                components.push(
                    <GearComponents.HMU
                        { ...defaultProps }
                        key="component-1"
                        type={ crewType.identifier === 'HAIR-STYLIST' ? 'hair' : 'makeup' }
                    />,
                )
                break
            case 'PHOTOGRAPHER':
                components.push(
                    <GearComponents.Cameras { ...defaultProps } key="component-1" type="still" />,
                    <GearComponents.Lenses { ...defaultProps } key="component-2" />,
                    <GearComponents.SupportEquipment { ...defaultProps } key="component-3" />,
                    <GearComponents.LightingKits { ...defaultProps } key="component-4" type="still" />,
                    <GearComponents.ComputersSimple { ...defaultProps } key="component-5" />,
                    <GearComponents.PhotographySkills { ...defaultProps } key="component-6" />,
                    <GearComponents.Monitors { ...defaultProps } key="component-7" />,
                )
                break
            case 'POST-SOUND':
                components.push(
                    <GearComponents.Software { ...defaultProps } key="component-1" type="audio" />,
                    <GearComponents.AdditionalSoftware { ...defaultProps } key="component-2" />,
                    <GearComponents.AdditionalHardware { ...defaultProps } key="component-3" />,
                    <GearComponents.SoundPostSkills { ...defaultProps } key="component-4" />,
                )
                break
            case 'PRODUCTION-ASSISTANT':
                components.push(
                    <GearComponents.ComputersSimple { ...defaultProps } key="component-1" />,
                    <GearComponents.Transportation { ...defaultProps } key="component-2" />,
                )
                break
            case 'PRODUCTION-DESIGNER':
                components.push(
                    <GearComponents.ProductionDesigner { ...defaultProps } key="component-1" />,
                    <GearComponents.Transportation { ...defaultProps } key="component-2" />,
                )
                break
            case 'SOUNDMIXER':
                components.push(
                    <GearComponents.AudioRecorders { ...defaultProps } key="component-1" />,
                    <GearComponents.Microphones { ...defaultProps } key="component-2" />,
                    <GearComponents.WirelessSystems { ...defaultProps } key="component-3" type="audio" />,
                    <GearComponents.SoundMixerAccessories { ...defaultProps } key="component-4" />,
                    <GearComponents.AdditionalGear
                        { ...defaultProps }
                        addLabel="Add item"
                        help="Please list additional equipment and accessories you own and want us to know about."
                        key="component-5"
                        title="Additional Production Sound Gear"
                    />,
                )
                break
            case 'STEADICAM-OPERATOR':
                components.push(
                    <GearComponents.Steadicam { ...defaultProps } key="component-1" />,
                )

                // add the video camera formset if the steadicam operator says they have a camera
                // package
                if (getProperty(this.state.data, 'steadicam_has_camera', false) === true) {
                    components.push(
                        <GearComponents.VideoWrapper { ...defaultProps } key="component-2" />,
                    )
                }

                components.push(
                )
                break
            case 'TELEPROMPTER':
                components.push(
                    <GearComponents.Teleprompter { ...defaultProps } key="component-1" />,
                )
                break
            case 'VIDEOGRAPHER':
                components.push(
                    <GearComponents.VideoWrapper { ...defaultProps } key="component-1" />,
                )
                break
            case 'VR':
                components.push(
                    <GearComponents.AdditionalInformation
                        { ...defaultProps }
                        key="component-1"
                        label={
                            'Please describe your VR kit. Include make, model, and number of ' +
                            'cameras you use. Please include all accessories as well.'
                        }
                    />,
                    <GearComponents.VRQuestions { ...defaultProps } key="component-2" />,
                    <GearComponents.ComputersSimple { ...defaultProps } key="component-3" />,
                )
                break
            case 'WARDROBE-STYLIST':
                components.push(
                    <GearComponents.WardrobeStylist { ...defaultProps } key="component-1" />,
                    <GearComponents.Transportation { ...defaultProps } key="component-2" />,
                )
                break

            // Handle the case where we don't know the crew type in question - just provide
            // "additional gear" plus the standard equipment list.
            default:
                components.push(
                    <GearComponents.AdditionalInformation
                        { ...defaultProps }
                        key="additional-information"
                        label={
                            'Please provide additional information about your selected crew ' +
                            'type. Include anything from equipment, to additional work links, ' +
                            'and/or anything else you can think of.'
                        }
                    />,
                )
        }

        components.push(
            <GearComponents.EquipmentList { ...defaultProps } key="equipment-list" />,
        )

        return components
    }

    render() {
        const personalData = this.props.personal.data

        if (! (personalData && this.state.crewType)) {
            return (
                <div>
                    <Header title="Gear" />

                    <div className="content">
                        <Loading />
                    </div>
                </div>
            )
        }

        const components = this._getComponentsForCrewType(this.state.crewType)

        return (
            <div>
                <Header title={ `Gear for ${ this.state.crewType.label }` } />

                <div className="content">
                    <Progress stage="gear" />

                    <div className="content__inner">
                        <div
                            className="alert alert--error"
                            style={{
                                textAlign: 'center',
                                fontSize: '22px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                marginBottom: 0,
                            }}
                        >
                            Only include equipment that you own.
                        </div>
                    </div>

                    { components }
                </div>
                <div className="submit-row">
                    <Button
                        buttonOnly
                        loading={ this.props.appState.loading }
                        onMouseDown={ this._commitGear }
                        status="primary"
                    >
                        Save
                    </Button>
                </div>
            </div>
        )
    }
}

export default Gear



// WEBPACK FOOTER //
// ./app/components/gear.js